"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarUsageChoiceWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var CarUsageChoiceWidget = exports.CarUsageChoiceWidget = /** @class */ (function (_super) {
    __extends(CarUsageChoiceWidget, _super);
    function CarUsageChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.businessUse = "Business";
        _this.socialUse = "Social";
        _this.state = {
            showInfo: false,
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    CarUsageChoiceWidget.prototype.componentDidMount = function () {
        var businessUse = this.props.interaction.vehicles[this.vehicleIndex].businessUse;
        if (businessUse !== null && businessUse !== undefined) {
            this.setState({ carIsForSocialUse: !businessUse, carIsForBusinessUse: businessUse });
        }
    };
    CarUsageChoiceWidget.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "form-group ".concat(this.state.showInfo ? 'background-color-grey inner-content negative-margin width-auto pt-3 pb-2' : '') },
            React.createElement("div", { className: "media" },
                React.createElement("div", { className: "row custom-polar-panel-text" }, this.renderHeader()),
                React.createElement("span", { className: "col-2" },
                    React.createElement("div", { tabIndex: 0, role: "button", className: this.state.showInfo ? "info-button selected" : "info-button", "aria-label": "Info button for more information about car usage", onKeyPress: function () {
                            _this.setState({ showInfo: !_this.state.showInfo });
                        } }))),
            React.createElement("div", { className: this.state.showInfo ? 'display-block border-100 pb-2' : 'display-none' },
                React.createElement("div", { className: "card shadow-none rounded" },
                    React.createElement("div", { className: this.state.showInfo ? 'card-body light-blue-background rounded' : 'background-color-white rounded' },
                        React.createElement("p", { className: "card-text", role: "alert" },
                            React.createElement("b", null, "Social, domestic and pleasure including commuting"),
                            " - includes commuting to a single place of work provided no business visits are made on the way."),
                        React.createElement("p", { className: "card-text", role: "alert" },
                            React.createElement("b", null, "Business use excluding Commercial Travelling"),
                            " - as well as social, domestic and pleasure use, your car is used for travelling to more than one place of work or the car is used in relation to your occupation (e.g. travelling to another location for work). This doesn't provide cover for travelling sales people."),
                        React.createElement("p", null),
                        React.createElement("p", { className: "card-text" }, "Unfortunately, we're not able to cover you if you're using your car for hire or reward (e.g. as a taxi, or as a fast food delivery driver).")))),
            React.createElement("div", null,
                React.createElement("div", { className: "custom-control margin-bottom-20-padding-left-0" },
                    React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: this.props.question.name + "-" + this.socialUse, id: this.props.question.name + "-" + this.socialUse, value: this.socialUse, checked: this.state.carIsForSocialUse, onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { id: 'driver-label', className: "checkbox-label label-bg-transparent", htmlFor: this.props.question.name + "-" + this.socialUse }, "Social, domestic and pleasure including commuting to one place to work")),
                React.createElement("div", { className: "custom-control margin-bottom-20-padding-left-0" },
                    React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: this.props.question.name + "-" + this.businessUse, id: this.props.question.name + "-" + this.businessUse, value: this.businessUse, checked: this.state.carIsForBusinessUse, onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { id: 'driver-label', className: "checkbox-label label-bg-transparent", htmlFor: this.props.question.name + "-" + this.businessUse }, "Business use excluding commercial travelling"))),
            this.validationErrorsPresent() && this.bindFromField(this.props.question.interactionField) === undefined && React.createElement("div", { className: "invalid-feedback d-block" }, "Please answer this to carry on")));
    };
    CarUsageChoiceWidget.prototype.handleOnChangeEvent = function (event) {
        var carIsForBusinessUse = event.currentTarget.value === this.businessUse;
        this.props.onStateChange(this.props.question.interactionField, carIsForBusinessUse);
        if (carIsForBusinessUse) {
            this.setState({
                carIsForBusinessUse: true,
                carIsForSocialUse: false
            });
        }
        else {
            this.setState({
                carIsForBusinessUse: false,
                carIsForSocialUse: true
            });
        }
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    CarUsageChoiceWidget.prototype.renderHeader = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        return (React.createElement("label", null,
            "What will the ",
            vehicle.make,
            ", ",
            vehicle.model,
            " (",
            vehicle.registrationNumber,
            ") be used for?"));
    };
    CarUsageChoiceWidget.prototype.validationErrorsPresent = function () {
        var _this = this;
        return Object.keys(this.props.validations).map(function (key) { return _this.props.validations[key]; }).some(function (v) { return !v.valid; });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], CarUsageChoiceWidget.prototype, "changelogRecorder", void 0);
    return CarUsageChoiceWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=CarUsageChoiceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CarUsageChoiceWidget.js
// module id = 3155
// module chunks = 0